import { combineReducers } from 'redux';
import entities from './entities/entityReducers';
import components from './components/componentReducers';
import commonServiceReducers from './commonServices/commonServiceReducers';
import progressReducer from './progress/progressReducer';
import spinnerReducer from './progress/spinnerReducer';

export default (combineReducers({
  entities,
  components,
  commonServiceReducers,
  progressReducer,
  spinnerReducer
}));
